import type { ReactNode } from "react";
import { Combobox as HeadlessUICombobox } from "@headlessui/react";
import classNames from "classnames";

export interface ComboboxComponentProps<T = unknown> {
  children: ReactNode;
  className?: string;
  onChange: (value: T) => void;
  value?: T | null;
}

export const ComboboxComponent = <T,>({
  children,
  value,
  onChange,
  className,
  ...rest
}: ComboboxComponentProps<T>) => (
  <div className={classNames("relative", className)}>
    <HeadlessUICombobox value={value} onChange={onChange} {...rest} nullable>
      {children}
    </HeadlessUICombobox>
  </div>
);
